export default __webpack_public_path__ + "static/media/rrdx1.1d7b5ecd.png";